<template>
  <div>
    <el-dialog :visible="true" width="560px">
      <div class="changeDialog">
        <div class="title">请输入手机号，领取兑换码</div>
        <div class="form">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item>
              <el-input v-model="form.phone" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                :disabled="form.phone === ''"
                @click="onSubmit"
              >
                领取
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="toast" v-show="changeSuccess">
          <div>兑换码: {{ code }}</div>
          <el-button
            class="copy_btn"
            type="primary"
            :data-clipboard-text="code"
            @click="copyContent()"
            >复制兑换码并前往兑换字数</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../http/api";
import Clipboard from "clipboard";

export default {
  data() {
    return {
      changeSuccess: false,
      form: { phone: "" },
      code: "",
    };
  },
  methods: {
    async onSubmit() {
      const res = await Api.Chat.getTicket({ phone: this.form.phone });

      if (res.error) {
        return this.$message.error("领取失败");
      }

      this.code = res.data.code;
      this.changeSuccess = true;
    },
    async copyContent() {
      const copyObj = new Clipboard(".copy_btn");

      copyObj.on("success", async () => {
        this.$message.success("复制成功");
        copyObj.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: row;
  padding: 0 96px;
  font-size: 23px;
  font-weight: 400;
  color: #111b3a;
  align-items: center;

  .text {
    flex: 1;
    margin-left: 28px;
  }
}
.buttonGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  .join,
  .change {
    font-size: 18px;
    font-weight: 500;
    color: #111b3a;
    border-radius: 8px;
  }
}

.title {
  font-size: 25px;
  font-weight: 400;
  color: #111b3a;
}

.changeDialog {
  display: flex;
  flex-direction: column;
  align-items: center;

  .form {
    margin-top: 16px;
  }
  .toast {
    display: flex;
    flex-direction: column;
    width: 200px;
    align-items: center;
    margin-bottom: 8px;
    font-size: 17px;
    font-weight: 500;
    color: #111b3a;

    .copy_btn {
      margin-top: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/changeForCount/index.vue